import { Vet } from './vet';
import { Service } from './service';

export class Appointment {

    uuid: string;
    start: any;
    end: any;
    title: string;
    color: any;
    status: number;
    actions: Array<any>;
    allDay: boolean;
    resizable: any;
    draggable: boolean;
    vetName: string;
    vetId: string;

    services: Array<Service>;
    comments?: string;

    public constructor(init?: Partial<Appointment>) {
        Object.assign(this, init);
    }
}
